module.exports = __webpack_public_path__ + "static/media/josefinsans_semibold.22108cbb.ttf";